import styled from 'styled-components'
import { theme } from '../../styles/theme'

interface IData {
  size?: number;
}

export const Container = styled.div`
`

export const Wrapper = styled.div``

export const WrapperCard = styled.div`
  background: ${theme.colors.secondGray};
  border-radius: ${theme.border.mediumRadius};
  &:nth-of-type(odd) {
    background: ${theme.colors.thirdLightGray};
  }
`

export const Header = styled.div`
  width: 100%;
  margin-top: 20px;
  margin-bottom: 20px;
  padding: 8px 28px;

  display: flex;
  align-items: center;
  justify-content: space-between;
`

export const WrapperRow = styled.div`
  width: 100%;
  height: 80px;
  margin-bottom: 12px;
`

export const Row = styled.div`
  position: relative;

  width: 100%;
  height: 80px;
  margin-bottom: 12px;
  padding: 8px 28px;

  border-radius: ${theme.border.mediumRadius};

  display: flex;
  align-items: center;
  justify-content: space-between;
`

export const DragIcon = styled.div`
  width: 4px;
  height: 20px;

  position: absolute;
  left: 8px;

  display: flex;
  flex-direction: column;
  gap: 4px;

  & > div {
    width: 4px;
    height: 4px;

    border-radius: 2px;
    background: #c4c4c4;
  }
`

export const Head = styled.div<IData>`
  width: ${({ size }) => (size ? `${size * 10}%` : '10%')};

  display: flex;
  align-items: center;

  font-size: ${theme.font.sizes.normal};
  line-height: ${theme.font.sizes.medium};
  color: ${theme.colors.black};
  font-family: ${theme.font.workSans};
`

export const Data = styled.div<IData>`
  width: ${({ size }) => (size ? `${size * 10}%` : '10%')};

  display: flex;
  align-items: center;
`

export const NoContentText = styled.span`
  margin-left: 25px;

  font-size: ${theme.font.sizes.small};
  line-height: ${theme.font.sizes.medium};
  color: ${theme.colors.darkGray};
  font-family: ${theme.font.workSans};
`
